import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { API_SERVICE } from '@/constants/api.constant';
import { GET, PUT } from '@/lib/fetch';
import type { ErrorApiResponse, SuccessResponse } from '@/types/response';
import type { UserReponse } from '@/types/user/user.response';

export const userQueries = {
	keys: 'users' as const,
	user: () =>
		queryOptions<SuccessResponse<UserReponse>, ErrorApiResponse>({
			queryKey: [userQueries.keys],
			queryFn: () => GET({ path: '/users', service: API_SERVICE.API })
		})
};

export const userMutations = {
	photo: mutationOptions<
		SuccessResponse<string>,
		ErrorApiResponse,
		{ profile_picture: string }
	>({
		mutationFn: (body) =>
			PUT(
				{
					path: `/users/profile-picture`,
					service: API_SERVICE.API
				},
				{ body }
			),
		meta: {
			invalidates: [userQueries.user().queryKey]
		}
	})
};
